/*
  Find a Retailer: Algolia search client.

  A minimal client for the multi-query endpoint, so the feature needs no
  library and no build step. It uses only the search-only key from the theme
  settings (see snippets/far-config.liquid) and never writes.

  window.PwFar.config(root)     reads the JSON config rendered inside root
  window.PwFar.algolia.search(config, requests)
    requests: [{ indexName, params: { filters, aroundLatLng, ... } }]
    resolves to Algolia's results array, one entry per request, in order.
*/
(function () {
  'use strict';

  var PwFar = (window.PwFar = window.PwFar || {});
  if (PwFar.algolia) return;

  var TIMEOUT_MS = 5000;

  PwFar.config = function (root) {
    var node = root && root.querySelector('[data-far-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  };

  function encodeParams(params) {
    return Object.keys(params)
      .filter(function (key) {
        return params[key] !== undefined && params[key] !== null;
      })
      .map(function (key) {
        var value = params[key];
        if (typeof value === 'object') value = JSON.stringify(value);
        return encodeURIComponent(key) + '=' + encodeURIComponent(value);
      })
      .join('&');
  }

  function hosts(appId) {
    var id = appId.toLowerCase();
    return [id + '-dsn.algolia.net', id + '-1.algolianet.com', id + '-2.algolianet.com', id + '-3.algolianet.com'];
  }

  function post(host, config, body) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, TIMEOUT_MS) : null;
    // Credentials in the query string and a form content type keep this a
    // CORS "simple" request, as Algolia's own browser client does, so no
    // preflight round trip precedes every search. The body is still JSON.
    var url =
      'https://' + host + '/1/indexes/*/queries' +
      '?x-algolia-application-id=' + encodeURIComponent(config.appId) +
      '&x-algolia-api-key=' + encodeURIComponent(config.searchKey);
    return fetch(url, {
      method: 'POST',
      credentials: 'omit',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: body,
      signal: controller ? controller.signal : undefined
    }).then(
      function (response) {
        if (timer) clearTimeout(timer);
        return response;
      },
      function (error) {
        if (timer) clearTimeout(timer);
        throw error;
      }
    );
  }

  PwFar.algolia = {
    ready: function (config) {
      return !!(config && config.appId && config.searchKey && config.retailerIndex);
    },

    search: function (config, requests) {
      if (!PwFar.algolia.ready(config)) {
        return Promise.reject(new Error('far: Algolia is not configured'));
      }
      var body = JSON.stringify({
        requests: requests.map(function (request) {
          return { indexName: request.indexName, params: encodeParams(request.params || {}) };
        })
      });
      var list = hosts(config.appId);

      // Network errors, timeouts and 5xx move on to the next host; a 4xx is
      // the request's fault and would fail everywhere.
      function attempt(i) {
        return post(list[i], config, body).then(
          function (response) {
            if (response.ok) return response.json().then(function (data) { return data.results; });
            if (response.status >= 500 && i + 1 < list.length) return attempt(i + 1);
            return response.text().then(function (text) {
              throw new Error('far: Algolia ' + response.status + ' ' + text);
            });
          },
          function (error) {
            if (i + 1 < list.length) return attempt(i + 1);
            throw error;
          }
        );
      }
      return attempt(0);
    },

    // Metres from the visitor to a hit, when the query had getRankingInfo.
    distance: function (hit) {
      var info = hit && hit._rankingInfo;
      if (info && info.matchedGeoLocation && typeof info.matchedGeoLocation.distance === 'number') {
        return info.matchedGeoLocation.distance;
      }
      return null;
    }
  };
})();
